import metaCtrlEnter from '@/directives/meta-ctrl-enter';

export default {
  'meta-ctrl-enter': metaCtrlEnter,
};
